import { observer } from "mobx-react-lite";
import React, { useContext, useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { useTranslation } from "react-i18next";

// reactstrap components
import { Row, Col } from "reactstrap";
import { translationHookOptions } from "../../app/localization/localization";
import { IScreenStatus } from "../../app/models/screens";
import ConnectNewScreenBox from "./ConnectNewScreenBox";
import LabelEditingButton from "./LabelEditingButton";
import PersonalScreenBox from "./PersonalScreenBox";
import { ReorderScreensComponent } from "./ReorderScreensComponent";
import ScreenDisconnectButton from "./ScreenDisconnectButton";
import ScreenLabelFormatter from "./ScreenLabelFormatter";
import ScreenSelectionCheckbox from "./ScreenSelectionCheckbox";
import UrlButton from "./UrlButton";
import { toast } from "react-toastify";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import { RootStoreContext } from "../../app/stores/rootStore";
import SelectedScreenButton from "../buttons/toolbar/SelectedScreenButton";

interface IParams {
  personalScreen: IScreenStatus | null;
  connectedScreens: IScreenStatus[];
}

const Screens: React.FC<IParams> = ({ personalScreen, connectedScreens }) => {
  const rootStore = useContext(RootStoreContext);
  const {
    isToShowToolbarScreens,
    selectedScreens,
  } = rootStore.screensStore;
  const { isMobileMediaQuery } = rootStore.responsiveStore;

  const [t] = useTranslation(["browse_page"], translationHookOptions);

  const editFormatterSelection = (
    cell: any,
    row: any,
    rowIndex: any,
    extra: any
  ) => {
    return (
      <>
        <ScreenSelectionCheckbox screen={row} />
      </>
    );
  };

  const orderFormatter = (cell: any, row: any, rowIndex: any, extra: any) => {
    return (
      <>
        <ReorderScreensComponent screenStatus={row} screensCount={extra} />
      </>
    );
  };

  const editFormatterOperation = (
    cell: any,
    row: any,
    rowIndex: any,
    extra: any
  ) => {
    return (
      <>
        <LabelEditingButton screen={row} />
        <ScreenDisconnectButton screen={row} />
      </>
    );
  };

  const urlFormatter = (cell: any, row: any, rowIndex: any, extra: any) => {
    return <UrlButton screen={row} />;
  };

  useEffect(() => {

      const scrollableElement = document.querySelector(".screenDiv");
      if (scrollableElement) {
        disableBodyScroll(scrollableElement, {
          allowTouchMove: (el) => el,
        });
      }

    return () => {
      const scrollableElement = document.querySelector(".screenDiv");
      if (scrollableElement) {
        enableBodyScroll(scrollableElement);
      }
    };
  });
  


  const columns = [
    {
      dataField: "name",
      text: t("screens_modal_table_screen_column"),
      classes: "customTableRow",
      headerClasses: "customTableHeaderRow",
    },
    {
      dataField: "code",
      text: t("screens_modal_table_code_column"),
      classes: "customTableRow  d-none d-sm-table-cell",
      headerClasses: "customTableHeaderRow  d-none d-sm-table-cell",
    },
    {
      dataField: "url",
      text: t("screens_modal_table_url_column"),
      formatter: urlFormatter,
      classes: "customTableRow  d-none d-sm-table-cell",
      headerClasses: "customTableHeaderRow  d-none d-sm-table-cell",
    },
    {
      dataField: "label",
      text: t("screens_modal_table_label_column"),
      formatter: (cell: any, row: any, rowIndex: any, extra: any) => (
        <ScreenLabelFormatter screen={row} />
      ),
      classes: "customTableRow  d-none d-sm-table-cell",
      headerClasses: "customTableHeaderRow  d-none d-sm-table-cell",
    },
    {
      dataField: "status",
      text: t("screens_modal_table_select_column"),
      formatter: editFormatterSelection,
      classes: "customTableRow",
      headerClasses: "customTableHeaderRow ",
    },
    {
      dataField: "ordinamento",
      isDummyField: true,
      text: t("screens_modal_table_order_column"),
      formatter: orderFormatter,
      formatExtraData: connectedScreens.length,
      classes: "customTableRow  d-none d-sm-table-cell",
      headerClasses: "customTableHeaderRow  d-none d-sm-table-cell",
    },
    {
      dataField: "operazioni",
      isDummyField: true,
      text: t("screens_modal_table_ops_column"),
      formatter: editFormatterOperation,
      classes: "customTableRow",
      headerClasses: "customTableHeaderRow",
    },
  ];

  return (
    <>
      <div className="screenDiv">
      {isMobileMediaQuery && (
            <div className="parentDivScreenIcon">
              {isToShowToolbarScreens ? (
                selectedScreens.map((s) => (
                  <div key={s.id} className="ml-2 divScreenIcon">
                    <SelectedScreenButton screen={s} />
                  </div>
                ))
              ) : (
                <></>
              )}
            </div>
          )}
        {/* {JSON.stringify(connectedScreens)} */}
        <Row className="">
          {personalScreen && (
            <Col md="12" xl="5" className="pl-2 pr-2 pb-1">
              <PersonalScreenBox screen={personalScreen} />
            </Col>
          )}
          <Col md="12" xl="7" className="pr-2 pl-2 pb-1">
            <ConnectNewScreenBox />
          </Col>
        </Row>

        <Row className="px-2 mt-3">
          <div className="card col-12 customScreensCard">
            <BootstrapTable
              classes="align-items-center screenTable"
              bodyClasses="screenTableBody"
              headerWrapperClasses="screenTableHeader"
              filterPosition="top"
              bootstrap4={true}
              bordered={false}
              wrapperClasses="table-responsive"
              columns={columns}
              keyField="id"
              data={connectedScreens}
            />
          </div>
        </Row>
      </div>
    </>
  );
};

export default observer(Screens);
